import { useEffect, useState } from 'react';
import {
  Typography,
  TextField,
  Grid,
  useTheme,
  Button,
  Container,
  Hidden,
  useMediaQuery,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Checkbox,
  FormControl,
  FormGroup,
  FormHelperText,
  Box,
  InputAdornment,
} from '@mui/material';
import { Field, Form, Formik } from 'formik';

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Person as PersonIcon, Mail as MailIcon } from '@mui/icons-material';
import Loading from 'react-fullscreen-loading';
import ReactCodeInput from 'react-code-input';
import signupSchool from '../../../assets/signupSchool.png';
import signupAlyosef from '../../../assets/alyousef/login.png';
import {
  firestore,
  auth,
  recaptchaVerifier,
  _customApp,
} from '@tabletuck/firebase-services';
import signup from '../../../assets/signup.gif';
import tabletuck from '../../../assets/tabletuck.gif';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { loggedInSuccess } from '@tabletuck/redux-slices';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import CustomPhoneNumber from '../../components/PhoneNumber/PhoneInput';
import './styles.css';
import { useTranslation } from 'react-i18next';
import { setCart, setUser, userAddresses } from '../../../../../../libs/redux-slices/src';
import banner from '../../../assets/background12.png';
import logo from '../../../assets/white-logo.png';
import { MdKeyboardArrowRight } from 'react-icons/md';

const SignUp = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
  const navigate = useNavigate();
  const [id, setId] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [expandForm, setExpandForm] = useState(false);
  const [OTP, setOTP] = useState('');
  const [verifiedNum, setVerifiedNum] = useState(false);
  const [user, setUserstate] = useState();
  const [open, setOpen] = useState(false);
  const [err, setErr] = useState('');
  const [t] = useTranslation();

  const storedItems = JSON.parse(localStorage.getItem('cartItems'));

 


  const openDialog = (user) => {
    if (!user?.fullName || !user?.email) {
      
      setAuthenticated(false);
      setOpen(true); 
    } else {
      
      setAuthenticated(true);
      setOpen(false);  
      navigate('/profile');
      dispatch(loggedInSuccess({ token: user?.uid }));
    }
  };
  
  
  
  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      if (!authenticated) {
        const formData = {
          email: values.email,
          fullName: values.fullName,
          sendSms: values.sendSms,
        };
        await firestore
          .collection('users')
          .doc(id)
          .set(formData, { merge: true })
          .catch((e) => {
            console.log(e);
          });
        setLoading(false);
        setAuthenticated(true);
        setOpen(false);
        setErr('');
        dispatch(loggedInSuccess({ token: user.uid }));
        window.location.href ="https://taqwasbakery.com/";
      } else {
        setLoading(false);
        setOpen(false);
        setErr('');
      }
    } catch (e) {
      console.log(e.message);
      setErr(`${t('tryAgain')}`);
      setLoading(false);
    }
  };
  let phoneNumbert = phoneNumber.toString();
  phoneNumbert = phoneNumbert.replace(/\s/g, '');
  phoneNumbert = phoneNumbert.replace(/-/g, '');
  phoneNumbert = phoneNumbert.replace(/[{()}]/g, '');
  phoneNumbert = '+1' + phoneNumbert;
  const handleSubmitt = async (values) => {
    setLoading(true);
    try {
      if (!user) {
        const authUser = await auth.currentUser;
        const doc = await firestore.collection('users').doc(authUser?.uid);
        await firestore
          .collection('users')
          .doc(doc?.id)
          .set({
            fullName: '',
            email: '',
            phoneNumber: phoneNumbert,
            uid: authUser.uid,
            bagItems: [],
            defaultPaymentAddress: '',
            defaultDeliveryAddress: '',
            defaultStore: '',
            pickupOrDelivery: '',
            creadtedAt: new Date(),
          })
          .then(async () => {
            await getUser(doc?.id);
            setErr('');
          });
      } else {
        openDialog(user);
      }
    } catch (e) {
      console.log('erorr', e.message);
      setErr(e.message);
      setLoading(false);
    }
  };


  const getUserAddress = async (userId, callback, handleErr) => {
    try {
      const addressesSnapshot = await firestore
        .collection('users')
        .doc(userId)
        .collection('addresses')
        .get();
  
      const addresses = [];
      addressesSnapshot.forEach((doc) => {
        addresses.push(doc.data()); // Push each address to the array
      });
  
      // Dispatch the addresses to Redux
      dispatch(userAddresses(addresses));
  
      // Call the callback with the fetched addresses
      if (callback) callback(addresses);
  
    } catch (e) {
      console.log('Error fetching addresses:', e);
      if (handleErr) handleErr(e); // Handle any errors
    }
  };
  


  const getUser = async (userId) => {
    setLoading(true); // Start loading
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }
  
      const userDoc = await firestore.collection('users').doc(userId).get();
       console.log("userDocData",userDoc?.data());
      if (userDoc?.exists) {
        setUserstate(userDoc?.data());
        dispatch(setUser({ userData: userDoc?.data() }));
        setId(userDoc?.id);
        window.localStorage.setItem('docid', userDoc?.id);
        await getUserAddress(userId, (addresses) => {
          console.log('User addresses:', addresses); // Debug log
        }, (error) => {
          console.error('Error fetching addresses:', error);
        });
        await LocalstorageAdd(userDoc?.data());
        openDialog(userDoc?.data());
      } else {
        console.log("Doc doesn't exist");
        handleSubmitt(); 
      }
    } catch (e) {
      console.log(e.message);
      setErr(e.message);
    } finally {
      setLoading(false); // Ensure loading is stopped
    }
  };
  

  const handlePinChange = (pinCode) => {
    setOTP(pinCode);
  
    if (pinCode.length === 6) {
      let confirmationResult = window.confirmationResult;
  
      confirmationResult
        .confirm(pinCode)
        .then(async (userCredential) => {
          const uid = userCredential?.user.uid;
  
          await getUser(uid);
  
          setErr('');
          setVerifiedNum(true); // After successful verification, check user data
        })
        .catch((e) => {
          console.log(e.message);
  
          let notCorrect =
            'The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code SMS and be sure to use the verification code provided by the user.';
          e.message === notCorrect
            ? setErr('Oops, incorrect code! Resend the code.')
            : setErr(e.message);
        });
    }
    setOTP(''); // Reset OTP after handling
  };
  
  const requestOTP = async (e) => {
    setErr('');
    dispatch(setCart([]));
    if (phoneNumbert.length < 12) {
      setErr(`${t('validNumber')}`);
      e.preventDefault();
    } else {
      setErr('');
      e.preventDefault();
      // setExpandForm(true);
      geterate();
      let appvarifier = window.recaptchaVerifier;
      await auth
        .signInWithPhoneNumber(phoneNumbert, appvarifier)
        .then((confirmationResult, result) => {
          setExpandForm(true);
          window.confirmationResult = confirmationResult;
          window.recaptchaVerifier = null;
          setErr('');
        })
        .catch((error) => {
          console.log('rechpecha error', error.message);
          window.recaptchaVerifier.reset();
          setExpandForm(false);
          setErr(`${t('validNumber')}`);
        });
    }
  };

  const geterate = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new recaptchaVerifier(
        'recaptcha-container',
        {
          size: 'invisible',
        },
        _customApp
      );
      // window.recaptchaVerifier.reset()

      // window.recaptchaVerifier.clear();
    } else window.recaptchaVerifier.render();
  };

  useEffect(() => {
    if (user && (!user.fullName || !user.email)) {
      openDialog(user);
    }
  }, [user]);



  const LocalstorageAdd = async (userdata) => {
    try {
      setUserstate(userdata);
      const firestoreItems = userdata?.bagItems;
      console.log("firestore items", firestoreItems);
  
      let items = [...firestoreItems];
      console.log("storedItems", storedItems);
  
      // Check if storedItems is null or undefined before calling forEach
      if (storedItems && Array.isArray(storedItems)) {
        storedItems?.forEach((newOption) => {
          const optionKeys = Object.keys(newOption?.customization);
          let optionIds = [];
          optionKeys?.forEach((key) => {
            const innerArray = newOption?.customization[key];
            const ids = innerArray?.map((item) => item?.id);
            optionIds = [...optionIds, ...ids];
          });
  
          let itemUpdated = false;
  
          items = items?.map((element) => {
            const elementKeys = Object.keys(element?.customization);
            let ids = [];
  
            elementKeys?.forEach((key) => {
              const innerArray = element?.customization[key];
              const innerIds = innerArray?.map((item) => item?.id);
              ids = [...ids, ...innerIds];
            });
  
            if (
              element?.itemId === newOption.itemId &&
              JSON.stringify(ids) === JSON.stringify(optionIds)
            ) {
              itemUpdated = true;
  
              return {
                ...element,
                quantity: element?.quantity + newOption?.quantity,
                calculatedPrice:
                  newOption?.calculatedPrice *
                  (element?.quantity + newOption?.quantity),
              };
            }
  
            return element;
          });
  
          if (!itemUpdated) {
            items.push(newOption);
          }
        });
      }
  
      console.log("all items", items);
      await firestore.collection('users').doc(auth?.currentUser?.uid).set(
        {
          bagItems: items,
        },
        { merge: true }
      );
  
      DispatchAllitems(items, doc?.data());
    } catch (error) {
      console.error('Error updating Firestore and local storage:', error);
    }
  };
  

  const DispatchAllitems = (items, user) => {
    const updatedUser = { ...user, bagItems: items };
    dispatch(setCart(items));
    dispatch(setUser({ userData: updatedUser }));
  };

  return (
    <Box maxWidth={'xl'}  style={{
                  backgroundColor:"#050505FC",
                          position: 'relative',
                          width: '100%',
                          height: '650px',
                          backgroundImage: `url(${banner})`,
                          backgroundRepeat: 'no-repeat',
            }}>
             
      <Grid container >

      <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{
        height: '100vh',
        backgroundImage: 'url(/path-to-your-background-image.jpg)', // Replace with your image path
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark overlay for readability
          padding: '30px',
          borderRadius: '10px',
          width: '100%',
          marginTop:"50px",
          
          maxWidth: '400px',
          textAlign: 'left',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
        }}
      >{
        open ? (
          <>
           < SignUpDailog open={open} handleSubmit={handleSubmit} />
          </>
        ):(
          <>
 {!expandForm ? (
          <>
        <Typography
          variant="h4"
          style={{
            fontWeight: 'bold',
            fontFamily:'Outfit',
            fontSize:'32px',
            color: '#fff',
            marginBottom: '5px',
            textAlign: 'left',
          }}
        >
          {t('signUp')}
        </Typography>

        <Typography
          variant="subtitle1"
          style={{
            fontFamily:'Outfit',
            fontSize:'16px',
            color: '#A9AFBA',
            marginBottom: '10px',
          }}
        >
          {t('Please fill your information below')}
        </Typography>
        </>
        ):(
          <>
          <Typography
            variant="h4"
            style={{
              fontWeight: 'bold',
              fontFamily:'Outfit',
              fontSize:'32px',
              color: '#fff',
              marginBottom: '5px',
              textAlign: 'left',
            }}
          >
            {t('Verify Phone Number')}
          </Typography>
  
          <Typography
            variant="subtitle1"
            style={{
              fontFamily:'Outfit',
              fontSize:'17px',
              color: '#A9AFBA',
              marginBottom: '10px',
            }}
          >
            {t('Please fill code we send in your phone num ')} 
            +1 {phoneNumber}
          </Typography>
          </>
        )}
        <div
          style={{
            borderRadius: '8px',
            display: 'block',
            // justifyContent: 'center',
            // alignItems: 'center',
            color: '#fff',
          }}
        >
          <PhoneVerificationForm
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            expandForm={expandForm}
            verifiedNum={verifiedNum}
            requestOTP={requestOTP}
            handlePinChange={handlePinChange}
            err={err}
            inputStyle={{
              backgroundColor: '#fff', // White background for input boxes
              borderRadius: '4px',
              border: '1px solid #ccc',
              padding: '10px',
              margin: '5px',
              fontSize: '16px',
              color: '#000', // Black text for readability
              width: '50px', // Adjust width for PIN inputs
              textAlign: 'center',
            }}
          />
        </div>
          </>
        )

      }
       

        {/* <Typography
          variant="body2"
          style={{
            color: 'lightgray',
            textDecoration: 'underline',
            cursor: 'pointer',
            marginTop: '15px',
          }}
        
        >
          {t('loginToAccount')}
        </Typography> */}
      </div>
    </Grid>

      </Grid>
      <Loading
        loading={!!loading}
        background="rgba(86, 100, 210, 0.1)"
        loaderColor={environment.mainColor}
      />
      
    </Box>
  );
};
export default SignUp;

const SignUpDailog = ({ open, handleSubmit }) => {
  const { t } = useTranslation();
  const validateSchema = Yup.object().shape({
    email: Yup.string().email('Invalid email').required('Email is a required field.'),
    fullName: Yup.string()
      .matches(/^[a-zA-Z\s]+$/, 'User name must be only characters.')
      .min(3, 'User name must be at least 3 characters.')
      .required('User name is a required field.'),
    sendSms: Yup.boolean().oneOf([true], 'You must agree to receive messages'),
  });
  return (
    <Formik
      initialValues={{
        firstName: '',
        email: '',
        sendSms: false,
      }}
      validationSchema={validateSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, handleSubmit, values, handleChange }) => (
        <Box>
          <Typography
           variant="h4"
           style={{
             fontWeight: 'bold',
             fontFamily:'Outfit',
             fontSize:'32px',
             color: '#fff',
             marginBottom: '5px',
             textAlign: 'left',
           }}>
            {t('Complete your profile')}
          </Typography>
         
            <Typography  variant="subtitle1"
            style={{
              fontFamily:'Outfit',
              fontSize:'17px',
              color: '#A9AFBA',
              marginBottom: '10px',
            }}>
              {t('Please fill your information below')}
            </Typography>
            <Grid item xs={12}>
            <Grid item xs={12} lg={12} style={{ paddingBottom: '10px' , marginTop:"30px" }}>
  <Field
    fullWidth
    as={TextField}
    variant="outlined"
    name="fullName"
    label="Full Name" 
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <PersonIcon style={{ color: '#D1D1D1' }} />
        </InputAdornment>
      ),
      style: { color: '#fff' },
    }}
    helperText={touched.fullName && errors.fullName}
    error={touched.fullName && errors.fullName && true}
    onChange={handleChange('fullName')}
    sx={{
      backgroundColor: 'transparent',
      color: '#fff',
      '& .MuiInputLabel-root': {
        color: '#D1D1D1',
        display: 'inline-block', 
        marginRight: '8px', 
      },
      '& label.Mui-focused': {
        color: '#fff', 
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        '& fieldset': {
          borderColor: '#262626',
        },
        '&:hover fieldset': {
          borderColor: environment.mainColor,
        },
        '&.Mui-focused fieldset': {
          borderColor: environment.mainColor,
        },
      },
    }}
  />
</Grid>

<Grid item xs={12} lg={12} style={{ paddingBottom: '10px' , marginTop:"12px"}}>
  <Field
    fullWidth
    as={TextField}
    variant="outlined"
    name="email"
    label="Email" 
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <MailIcon style={{ color: '#D1D1D1' }} />
        </InputAdornment>
      ),
      style: { color: '#fff' },
    }}
    helperText={touched.email && errors.email}
    error={touched.email && errors.email && true}
    onChange={handleChange('email')}
    sx={{
      backgroundColor: 'transparent',
      color: '#fff',
      '& .MuiInputLabel-root': {
        color: '#D1D1D1',
        display: 'inline-block', 
        marginRight: '8px', 
      },
      '& label.Mui-focused': {
        color: '#fff',
      },
      '& .MuiOutlinedInput-root': {
        borderRadius: '12px',
        '& fieldset': {
          borderColor: '#262626',
        },
        '&:hover fieldset': {
          borderColor: environment.mainColor,
        },
        '&.Mui-focused fieldset': {
          borderColor: environment.mainColor,
        },
      },
    }}
  />
</Grid>


              <FormControl
                required
                error={touched.sendSms && Boolean(errors.sendSms)}
                component="fieldset"
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.sendSms}
                        onChange={handleChange('sendSms')}
                        sx={{
                          color: '#A9AFBA', 
                          '&.Mui-checked': {
                            color: environment.mainColor, 
                          },
                        }}
                      />
                    }
                    label="You agree to receive sms messages from our website"
                    sx={{
                      '& .MuiFormControlLabel-label': {
                        color: '#A9AFBA',
                        fontFamily: 'Outfit', 
                        fontSize: '13px',
                        marginTop:'10px',
                      },}}
                  />
                </FormGroup>
                {touched.sendSms && errors.sendSms && (
                  <FormHelperText>{errors.sendSms}</FormHelperText>
                )}
              </FormControl>
            </Grid>
         
          <Box style={{ display: 'flex', justifyContent: 'end' }}>
            <Button
              onClick={handleSubmit}
              type="submit"
              variant="contained"
              style={{
                backgroundColor: environment.mainColor,
                marginTop: '15px',
                padding:"5px 20px",
                borderRadius:"20px",
                textTransform:"capitalize",
                fontFamily:"Outfit",
              }}
            >
             {t('Next')}<span><MdKeyboardArrowRight size={18} sx={{ml:2}}/></span>
            </Button>
            </Box>
        </Box>
      )}
    </Formik>
  );
};

const PhoneVerificationForm = ({
  phoneNumber,
  setPhoneNumber,
  expandForm,
  verifiedNum,
  requestOTP,
  handlePinChange,
  err,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
  const props = {
   
    inputStyle: {
      fontFamily: 'Outfit',
      margin:  '4px',
      MozAppearance: 'textfield',
      width: '40px',
      fontSize: '22px',
      height: '45px',
      padding: '15px 10px',
      color: 'white',
      backgroundColor: 'transparent', 
      border: '1px solid  #262626',
      borderRadius:'12px',
    },
    inputStyleInvalid: {
      fontFamily: 'monospace',
      margin:  '4px',
      MozAppearance: 'textfield',
      width: '15px',
      borderRadius: '3px',
      fontSize: '14px',
      height: '26px',
      paddingLeft: '7px',
      backgroundColor: 'black',
      color: 'red',
      border: '1px solid red'
    }
  }

  return (
    <>
    <Formik
      initialValues={{
        phoneNumber: '',
      }}
    >
      {() => (
        <>
          <Grid spacing={3} container>
            <Grid
              item
              justify="space-between"
              container
              xs={12}
              spacing={1}
              style={{
                flexDirection: xsDown ? 'row' : 'unset',
                marginTop: '10px',
              }}
            >
              <Grid
                item
                xs={12}
                lg={12}
                style={{ display: 'flex', justifyContent: 'center' , color: '#fff',}}
              >
          
<Form onSubmit={requestOTP}>
{!expandForm && (
  <>
<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
<Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        padding: '11px 10px',
        borderRadius: '12px',
        border: '1px solid #262626',
      }}
    >
      <img
        src="https://flagcdn.com/w40/us.png"
        alt="USA Flag"
        width="20"
        height="15"
        style={{ borderRadius: '2px' }}
      />
      <span style={{ color: '#fff', fontWeight: 'bold' }}>+1</span>
    </Box>

  <Field
    fullWidth
    as={CustomPhoneNumber}
    variant="outlined"
    name="phoneNumber"
    label="Mobile Number"
    required
    value={phoneNumber}
    onChange={(e) => setPhoneNumber(e.target.value)}
    InputProps={{
      style: {
        color: '#fff', 
      },
      readOnly: expandForm ? true : false,
    }}
    disabled={expandForm ? true : false}
   
    InputLabelProps={{
      shrink: true, 
      style: { color: '#D1D1D1' ,fontFamily:"Outfit" ,fontSize:"18px"},
      required:false, 
    }}
    sx={{
      borderRadius: '8px',
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderColor: "#262626", 
          borderRadius: '12px',
        },
        '&:hover fieldset': {
          borderColor: "#A01913",
          borderRadius: '12px',
        },
        '&.Mui-focused fieldset': {
          borderColor: "#A01913", 
          borderRadius: '12px',
        },
      },
    }}
  />
  </Box>
  <br />
  
    <Box style={{ display: 'flex', justifyContent: 'end' }}>
      <Button
        size="small"
        type="submit"
        variant="contained"
        style={{
          backgroundColor: environment.mainColor,
          marginTop: '15px',
          padding:"5px 20px",
          borderRadius:"20px",
          textTransform:"capitalize",
          fontFamily:"Outfit",
        }}
      >
        {t('Next')}<span><MdKeyboardArrowRight size={18} sx={{ml:2}}/></span>
      </Button>
    </Box>
    </>
  )}
   <div style={{ height: '10px', width: '100px' }} />
                  {expandForm === true && verifiedNum === false && (
                    <>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          direction: 'initial',
                        }}
                      >
                        <ReactCodeInput
                          type="text"
                          onChange={handlePinChange}
                          fields={6}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          {...props}
                        />
                      </div>
                      <br />
                    </>
                  )}
                
    <div id="recaptcha-container"></div>
</Form>


              </Grid>
            </Grid>
          </Grid>
          

        </>
      )}
    </Formik>
    <br></br>
    <Box style={{ display: 'block', marginTop: '10px', textAlign: 'center' }}>
    <Typography
      variant="body1" 
      style={{
        color: 'red',
        fontSize: 15,
      }}
    >
      {err}
    </Typography>
  </Box>
  </>
  );
};
